import { apiClient, type ApiClientResponse, type ApiPaginatedResponse } from '@/datasources/apiClient'

export interface App {
  id: string
  name: string
  orgId: string
  orgName?: string
  createdByEmail: string
  servicesCount: number
  createdAt: string
  updatedAt: string
}

export const fetchAppsApi = (page = 1, pageSize = 20): Promise<ApiPaginatedResponse<App>> =>
  apiClient.get('/api/v1/apps', { params: { page, pageSize } }).then((r) => r.data)

export const createAppApi = (name: string): Promise<ApiClientResponse<App>> =>
  apiClient.post('/api/v1/apps', { name }).then((r) => r.data)

export const getAppApi = (appId: string): Promise<ApiClientResponse<App>> =>
  apiClient.get(`/api/v1/apps/${appId}`).then((r) => r.data)

export const updateAppApi = (appId: string, name: string): Promise<ApiClientResponse<App>> =>
  apiClient.patch(`/api/v1/apps/${appId}`, { name }).then((r) => r.data)

export const deleteAppApi = (appId: string): Promise<ApiClientResponse<null>> =>
  apiClient.delete(`/api/v1/apps/${appId}`).then((r) => r.data)
